export default `/* Ids Container Component */
:host {
  display: block;
  contain: none;
  height: 100dvh;
  width: 100vw;
}

:host([hidden]) {
  display: none;
}

:host(:not([hidden])) {
  display: block;
}

:host([animated][hidden]) {
  animation: fadeOut var(--ids-motion-duration) var(--ids-motion-ease) forwards;
}

:host([animated]:not([hidden])) {
  display: block;
  animation: fadeIn var(--ids-motion-duration) var(--ids-motion-ease) forwards;
}

:host([container-queries]) {
  container-type: inline-size;
}

.ids-container {
  background-color: var(--ids-color-background-default);
  box-sizing: border-box;
  color: var(--ids-color-text-default);
  height: 100%;
  line-height: normal;
  outline: none;
  overflow: auto;
  padding: var(--ids-space-none);
  scroll-behavior: smooth;
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease);
  width: 100%;
}
.ids-container.color-variant-alternate {
  background-color: var(--ids-color-text-default);
  color: var(--ids-color-text-inverse);
}
.ids-container[scrollable=false] {
  overflow: hidden;
}

@media (min-width: 927px) {
  :host(.app-menu)::part(container) {
    margin-bottom: var(--ids-space-none);
    transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease);
    transition: width var(--ids-motion-duration) var(--ids-motion-ease), margin var(--ids-motion-duration) var(--ids-motion-ease);
  }
}

@media (min-width: 927px) {
  :host(.app-menu-is-open)::part(container) {
    margin-inline-start: 300px;
    width: calc(100% - 300px);
    transition: width var(--ids-motion-duration) var(--ids-motion-ease), margin var(--ids-motion-duration) var(--ids-motion-ease);
  }
}

@keyframes fadeIn {
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: block;
  }
  100% {
    display: block;
    opacity: 1;
  }
}
@keyframes fadeOut {
  0% {
    display: block;
    opacity: 1;
  }
  99% {
    display: block;
  }
  100% {
    display: none;
    opacity: 0;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
